import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

// UI strings live in /public/locales/{{lng}}.json and are maintained by hand today.
// We only ship en.json and fr.json, but the language master can list any number of
// extra languages (de, es, ...). When the user switches to one of those, i18next
// tries to load the matching file — which doesn't exist — and would normally throw.
// We intercept the HTTP request, treat 404 as an empty bundle, and rely on
// `fallbackLng: 'en'` to render English UI labels. Master-data labels keep working
// because they resolve via the localStorage cache, not these files.
const tolerantRequest = (options, url, payload, callback) => {
    fetch(url)
        .then(async (res) => {
            if (res.status === 404) {
                // Silent fallback — no error, empty bundle, English wins via fallbackLng.
                return callback(null, { status: 200, data: '{}' });
            }
            const text = await res.text();
            return callback(null, { status: res.status, data: text });
        })
        .catch((err) => callback(err, null));
};

i18n
    .use(HttpBackend) // Load translations from files
    .use(LanguageDetector) // Detect language from browser/localStorage
    .use(initReactI18next) // Pass i18n to react-i18next
    .init({
        // Intentionally NOT restricting supportedLngs: the language master drives the
        // available list at runtime. Any code picked from the header popup is accepted,
        // missing UI-string files fall back to English automatically.
        fallbackLng: "en",
        // Hard default: English. If localStorage already has a saved choice the
        // detector still honours it, but on a fresh install / cleared storage the
        // app boots in English instead of the browser's system language.
        lng: typeof window !== 'undefined' && window.localStorage
            ? (window.localStorage.getItem('i18nextLng') || 'en')
            : 'en',
        load: 'currentOnly',
        debug: false,
        backend: {
            loadPath: "/locales/{{lng}}.json",
            request: tolerantRequest,
        },
        detection: {
            // Only localStorage — never fall through to navigator/browser language.
            // This guarantees a fresh user sees English first; a returning user who
            // previously picked a different language still gets their choice.
            order: ['localStorage'],
            caches: ['localStorage'],
        },
        interpolation: {
            escapeValue: false // React already escapes HTML
        }
    });

export default i18n;
